import axiosInstance from "./api";
import { httpAPI } from "./status";

const isUseHttpAPi = (url: string, isUse: boolean) => {
  let realUrl = null;

  if (isUse) {
    realUrl = url;
  } else {
    realUrl = `${httpAPI}${url}`;
  }

  return realUrl;
};

const http = {
  get: (url: string, params?: any, useInterNetAPI?: boolean, headers?: any) => {
    let realUrl = isUseHttpAPi(url, useInterNetAPI || false);

    return axiosInstance.get(realUrl, {
      method: "GET",
      url: realUrl,
      params,
      headers: {
        ...headers,
      },
    }) as any;
  },
  post: (url: string, data?: any, useInterNetAPI?: boolean) => {
    let realUrl = isUseHttpAPi(url, useInterNetAPI || false);

    if (data && "" + data.tempSaveStep) {
      if (
        data.tempSaveStep === 0 ||
        ("" + data.tempSaveStep).trim() === "0" ||
        ("" + data.tempSaveStep).trim() === ""
      ) {
        data.tempSaveStep = null;
      }
    }

    return axiosInstance.post(realUrl, {
      ...data,
    }) as any;
  },
};

export default http;
